import ScrollReveal from 'scrollreveal'

const SELECTORS = {
  GRID_ITEM: '.product-grid-item',
  GRID_CONTAINER: '#ProductGrid',
  PAGINATION_LINK: '#ProductGridPagination > .next > a',
  SPINNER_ICON: '.spinner',
}

const scrollReveal = ScrollReveal()
const opts = {
  delay: 220,
  duration: 330,
  distance: '1rem',
  easing: 'cubic-bezier(0.455, 0.030, 0.515, 0.955)',
  opacity: 0,
  scale: 1,
}

let stopLoading = false

const $productGrid = $(SELECTORS.GRID_CONTAINER)
const $paginationLink = $(SELECTORS.PAGINATION_LINK)
const $spinnerIcon = $(SELECTORS.SPINNER_ICON)

const SPINNER_VISIBLE_CLASS = 'spinner--is-visible'

export default () => {
  if (!scrollReveal.isSupported()) {
    $('html').addClass('no-scrollreveal')
  }

  scrollReveal.reveal(SELECTORS.GRID_ITEM, opts)

  loadItems()

  $(document).on('scroll', () => {
    const gridOffset = $productGrid.offset().top
    if (gridOffset + $(document).scrollTop() + $(window).height() >= $productGrid.height()) {
      if (!stopLoading) {
        loadItems()
      }
    }
  })
}

function loadItems() {

  if (stopLoading) {
    return
  }

  stopLoading = true

  const paginationHref = $paginationLink.attr('href')

  if (typeof paginationHref === 'undefined') {
    return
  }

  $.ajax({
    url: paginationHref,
    dataType: 'html',
    beforeSend: (xhr) => {
      $spinnerIcon.addClass(SPINNER_VISIBLE_CLASS)
    }
  }).done((responseText) => {
      $spinnerIcon.removeClass(SPINNER_VISIBLE_CLASS)

      const $response = $($.parseHTML(responseText))
      const $pagination = $response.find(SELECTORS.PAGINATION_LINK)
      const $gridItems = $response.find(SELECTORS.GRID_ITEM)
      const loadedPaginationHref = $pagination.attr('href')

      $(SELECTORS.GRID_CONTAINER).append($gridItems)
      scrollReveal.sync()

      $spinnerIcon.removeClass(SPINNER_VISIBLE_CLASS)

      // update next page href
      if (!$pagination.length || !loadedPaginationHref) {
        console.debug('No more pages to load.')
        stopLoading = true
        return
      }

      if (loadedPaginationHref === paginationHref) {
        $paginationLink.remove()
        stopLoading = true
      } else {
        $paginationLink.attr('href', loadedPaginationHref)
        stopLoading = false
      }
    })
}



// WEBPACK FOOTER //
// ./product-grid.js